import { render, staticRenderFns } from "./about-us-company.vue?vue&type=template&id=5f72a363&scoped=true&"
import script from "./about-us-company.vue?vue&type=script&lang=js&"
export * from "./about-us-company.vue?vue&type=script&lang=js&"
import style0 from "./about-us-company.vue?vue&type=style&index=0&id=5f72a363&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72a363",
  null
  
)

export default component.exports